/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, identity, RestSettings } from '@gh/core-data';
import { S3UploadAuthService, S3UploadConfig, S3UploadItem } from '@gh/core-ui';
import { isNil } from 'lodash';
import { Observable } from 'rxjs';

@Injectable()
export class AppS3UploadAuthService extends AbstractRestService implements S3UploadAuthService {

  constructor(private settings: RestSettings) {
    super(settings);
  }

  getConfig(item: S3UploadItem, params: Hash<any>): Observable<S3UploadConfig> {
    const { entryPoint } = params;
    const { name } = item;

    if (isNil(entryPoint)) {
      throw new Error('Entry point is not defined for "init upload" endpoint');
    }

    return this.httpGet(`${this.bp}/pictures/init-upload`, { entryPoint, fileName: name }, void 0, identity());
  }
}
